import { AppRole, AppRoleErrorCode } from '../types/rbac.types'

export const ROLE_LABELS: Record<AppRole, string> = {
  viewer: 'Lecteur',
  operator: 'Opérateur',
  editor: 'Éditeur',
  admin: 'Administrateur',
}

export const roleLabel = (role: AppRole | '' | null | undefined): string =>
  role ? ROLE_LABELS[role] : 'Aucun rôle'

export const rbacStrings = {
  notAllowed: (role: AppRole | '' | null | undefined) =>
    `Action non autorisée pour votre rôle (${roleLabel(role)})`,
  pageNotAllowed: "Vous n'avez pas les droits nécessaires pour accéder à cette page.",
  loading: 'Chargement…',
  unavailable: 'Les droits d’accès sont momentanément indisponibles. Réessayez plus tard.',
  editRightsRevokedUnsaved: (count: number) =>
    `Vos droits d'édition ont été retirés : ${count} modification(s) non enregistrée(s) ne pourront pas être sauvegardées.`,

  // Page « Rôles & accès »
  pageTitle: 'Rôles & accès',
  pageIntro:
    'Attribuez un rôle à chaque membre du compte. Les rôles sont cumulatifs : Lecteur ⊂ Opérateur ⊂ Éditeur ⊂ Administrateur.',
  colName: 'Nom',
  colEmail: 'Email',
  colRole: 'Rôle',
  colSource: 'Origine',
  colStatus: 'Statut',
  sourceDefault: 'Par défaut',
  sourceAssigned: 'Assigné',
  sourceRole8000: 'Rôle 8000',
  // Rôle 8000 sans Mini-grid : le membre n'a aucun accès à Mini-grid.
  noAccess: 'Aucun accès',
  managedBy8000: 'Défini par le rôle 8000 de ce membre (page Utilisateurs et Roles de la 8000).',
  suspended: 'Suspendu',
  active: 'Actif',
  accountAdmin: 'Admin du compte',
  noMembers: 'Aucun membre sur ce compte.',
  listError: 'Impossible de charger les membres du compte.',
  listForbidden: "Vous n'avez pas les droits pour consulter les rôles de ce compte.",
  saved: 'Rôle mis à jour.',
  saving: 'Enregistrement…',
}

export const APP_ROLE_ERROR_MESSAGES: Record<AppRoleErrorCode, string> = {
  last_admin: 'Impossible de retirer le dernier administrateur du compte',
  busy_retry:
    'Une autre modification des rôles est en cours. Veuillez réessayer dans quelques instants.',
  managed_by_8000_role:
    'Le rôle Mini-grid de ce membre est défini par son rôle 8000 : modifiez-le dans la page Utilisateurs et Roles de la 8000.',
  forbidden: "Vous n'avez pas les droits pour modifier les rôles de ce compte.",
  not_member_of_account: "Cet utilisateur n'est pas membre de ce compte.",
  invalid_role: 'Rôle invalide.',
  invalid_user: "Identifiant d'utilisateur invalide.",
  rbac_unavailable:
    'Le service de gestion des rôles est momentanément indisponible. Réessayez plus tard.',
  unauthorized: 'Session expirée, veuillez vous reconnecter.',
  unknown: 'Erreur lors de la mise à jour du rôle.',
}
